// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Header from "./Componants/Header1";
// import About from "./Componants1/About";
// import Services from "./Componants1/Services1";
// import Contact from "./Componants1/Contact";
// import Footer from "./Componants1/Footer1";
// import Experience from "./Componants1/Experience1";
// import Intro from "./Componants1/Intro1";
// import ScrollTop from "./ScrollTop";
// import WhyChoose from "./Componants1/WhyChoose1";
// import HomeTechnologies from "./Componants1/Tech1";
// import Web from "./Componants1/Services/web";
// import MobileDevelopment from "./Componants1/Services/Mob";
// import Ecommerce from "./Componants1/Services/ECommerce";
// import Salesforce from "./Componants1/Services/Saleforce";
// import StaffAugmentation from "./Componants1/Services/StaffAug";

// function Main1() {
//   return (
//     <Router>
//       {/* Header always visible */}
//       <ScrollTop/>
//       {/* <Header /> */}

//       {/* Pages rendered below header */}
//       <div className="pt-22"> {/* padding top = header height */}
//         <Routes>
//           {/* Only show Intro on /home */}
//           <Route path="/home" element={<Intro />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/services" element={<Services />} />
//           <Route path="/contact" element={<Contact />} />
//           <Route path="/experience" element={<Experience />} />
//           <Route path="/whychoose" element={<WhyChoose />} />
//           <Route path="/web" element={<Web/>}/>
//            <Route path="/mob" element={<MobileDevelopment/>}/>
//             <Route path="/ecom" element={<Ecommerce/>}/>
//              <Route path="/salesforce" element={<Salesforce/>}/>
//              <Route path="/staff" element={<StaffAugmentation/>}/>

//           {/* Default route: redirect to /home */}
//           <Route path="/technology" element={< HomeTechnologies/>} />
//                 {/* Default route: redirect to /home */}
//         <Route path="*" element={<Navigate to="/home" />} />
//         </Routes>
//       </div>

//       <Footer />
//     </Router>
//   );
// }

// export default Main1;


import { Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";

import ScrollTop from "./ScrollTop";
import Intro from "./Componants1/Intro1";
import About from "./Componants1/About";
import Services from "./Componants1/Services1";
import Contact from "./Componants1/Contact";
import Experience from "./Componants1/Experience1";
import WhyChoose from "./Componants1/WhyChoose1";
import HomeTechnologies from "./Componants1/Tech1";
import Web from "./Componants1/Services/web";
import MobileDevelopment from "./Componants1/Services/Mob";
import Ecommerce from "./Componants1/Services/ECommerce";
import Salesforce from "./Componants1/Services/Saleforce";
import StaffAugmentation from "./Componants1/Services/StaffAug";
import Footer from "./Componants1/Footer1";

export default function Main1() {
  return (
    <div className="pt-0">
      <ScrollTop />

      <Routes>
        <Route path="/home" element={<Intro />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/whychoose" element={<WhyChoose />} />
        <Route path="/technology" element={<HomeTechnologies />} />

        <Route path="/web" element={<Web />} />
        <Route path="/mob" element={<MobileDevelopment />} />
        <Route path="/ecom" element={<Ecommerce />} />
        <Route path="/salesforce" element={<Salesforce />} />
        <Route path="/staff" element={<StaffAugmentation />} />

        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
      <Footer/>
    </div>
  );
}
